// removed by extract-text-webpack-plugin
module.exports = {"link":"_14eAif0h2zg-oY-LVMKwpG"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Services/Services.stylesheet.css
// module id = 235
// module chunks = 0